"use client";

import React from "react";

import { CustomModal } from "@/components/ui/CustomModal";

type RichTextLinkModalProps = {
  open: boolean;
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
  onApply: () => void;
};

export function RichTextLinkModal({
  open,
  value,
  onChange,
  onClose,
  onApply,
}: RichTextLinkModalProps) {
  return (
    <CustomModal
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) onClose();
      }}
      maxWidth="max-w-sm"
      bodyClassName="p-4"
      closeOnOutsideClick={false}
    >
      <div className="space-y-4">
        <h2 className="text-lg font-semibold text-gray-900">Insert link</h2>
        <div className="space-y-3">
          <label className="space-y-2 text-sm text-gray-700">
            <span className="font-medium text-gray-800">URL</span>
            <input
              type="url"
              className="focus:border-pinkCustom w-full rounded-md border border-gray-200 px-3 py-2 text-gray-800 transition outline-none"
              placeholder="https://example.com"
              value={value}
              onChange={(event) => onChange(event.target.value)}
              autoFocus
            />
          </label>
          <div className="mt-2 flex justify-end gap-2">
            <button
              type="button"
              className="rounded-md border border-gray-200 px-3 py-1.5 text-sm font-medium text-gray-700 hover:bg-gray-100"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="bg-pinkCustom rounded-md px-4 py-1.5 text-sm font-semibold text-white hover:opacity-90 disabled:opacity-60"
              disabled={!value.trim()}
              onClick={onApply}
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    </CustomModal>
  );
}
